import React from 'react'

const UserIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 21 20" fill="none">
      <path d="M16.9998 17.5C16.9998 16.337 16.9998 15.7555 16.8563 15.2824C16.5331 14.217 15.6995 13.3834 14.6341 13.0602C14.161 12.9167 13.5795 12.9167 12.4165 12.9167H8.24984C7.08687 12.9167 6.50538 12.9167 6.03222 13.0602C4.96688 13.3834 4.1332 14.217 3.81004 15.2824C3.6665 15.7555 3.6665 16.337 3.6665 17.5M14.0832 6.25C14.0832 8.32107 12.4042 10 10.3332 10C8.2621 10 6.58317 8.32107 6.58317 6.25C6.58317 4.17893 8.2621 2.5 10.3332 2.5C12.4042 2.5 14.0832 4.17893 14.0832 6.25Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default UserIcon
